import { gql } from '@apollo/client';
const GET_DIRECT_CONVERSATIONS = gql `
  query GetDirectConversations {
    getDirectConversations {
      id
      title
      members {
        edges {
          node {
            id
            user {
              id
              username
              email
              avatar
            }
          }
        }
      }
    }
  }
`;
export default GET_DIRECT_CONVERSATIONS;
